package pl.mothdigital.neuronowi.theme.text

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.cssRem

val TextBaseStyle = CssStyle {
    base { Modifier.fontSize(1.cssRem).lineHeight(1.5.cssRem) }
}
